import { NgModule } from '@angular/core';
import { BeaconstacComponent } from './beaconstac.component';
import {CommonModule} from '@angular/common';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {ModalModule} from 'ngx-bootstrap/modal';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import { ButtonsComponent } from './buttons/buttons.component';
import { CheckboxesComponent } from './checkboxes/checkboxes.component';
import { DropdownsComponent } from './dropdowns/dropdowns.component';
import { MessagesComponent } from './messages/messages.component';
import { PaginationsComponent } from './paginations/paginations.component';
import { RadioButtonsComponent } from './radio-buttons/radio-buttons.component';
import { SlidersComponent } from './sliders/sliders.component';
import { TextfieldsComponent } from './textfields/textfields.component';
import { TitlesComponent } from './titles/titles.component';
import { ToastsComponent } from './toasts/toasts.component';
import { TogglesComponent } from './toggles/toggles.component';
import { TagsComponent } from './tags/tags.component';
import { SearchComponent } from './search/search.component';
import { FilterDropdownComponent } from './filter-dropdown/filter-dropdown.component';
import { TableComponent } from './table/table.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import {FormsModule} from '@angular/forms';
import { OptionsComponent } from './options/options.component';
import {UploadComponent} from './upload/upload.component';
import {NgxFileDropModule} from 'ngx-file-drop';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ColorPickerModule } from 'ngx-color-picker';
import {ColorPickerComponent} from './color-picker/color-picker.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SpinnerComponent } from './spinner/spinner.component';
import { InputGroupComponent } from './input-group/input-group.component';
import {IntlTelInputComponent} from './intl-tel-input/intl-tel-input.component';


@NgModule({
  declarations: [
    BeaconstacComponent,
    ButtonsComponent,
    CheckboxesComponent,
    DropdownsComponent,
    MessagesComponent,
    PaginationsComponent,
    RadioButtonsComponent,
    SlidersComponent,
    TextfieldsComponent,
    TitlesComponent,
    ToastsComponent,
    TogglesComponent,
    TagsComponent,
    SearchComponent,
    FilterDropdownComponent,
    TableComponent,
    TooltipComponent,
    OptionsComponent,
    UploadComponent,
    ProgressBarComponent,
    ColorPickerComponent,
    SpinnerComponent,
    InputGroupComponent,
    IntlTelInputComponent
  ],
  imports: [
    CommonModule,
    NgxSliderModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    FormsModule,
    NgxFileDropModule,
    InfiniteScrollModule,
    ColorPickerModule
  ],
  exports: [
    ButtonsComponent,
    CheckboxesComponent,
    DropdownsComponent,
    MessagesComponent,
    PaginationsComponent,
    RadioButtonsComponent,
    SlidersComponent,
    TextfieldsComponent,
    TitlesComponent,
    ToastsComponent,
    TogglesComponent,
    TagsComponent,
    SearchComponent,
    FilterDropdownComponent,
    TableComponent,
    TooltipComponent,
    OptionsComponent,
    UploadComponent,
    ProgressBarComponent,
    ColorPickerComponent,
    SpinnerComponent,
    InputGroupComponent,
    IntlTelInputComponent
  ]
})
export class BeaconstacModule { }
